/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockStopwatchIcon16Regular = forwardRef('TimeClockStopwatchIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 5a.75.75 0 0 1 .75.75V9a.75.75 0 0 1-1.5 0V5.75A.75.75 0 0 1 8 5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.75 0a.75.75 0 0 0 0 1.5h1.5v1.043a6.501 6.501 0 1 0 5.846 2.422l.934-.935a.75.75 0 0 0-1.06-1.06l-.935.934A6.468 6.468 0 0 0 8.75 2.543V1.5h1.5a.75.75 0 0 0 0-1.5h-4.5ZM8 4a5 5 0 1 0 0 10A5 5 0 0 0 8 4Z" })));
});
